/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { killswitchesListCapabilities } from "../funcs/killswitchesListCapabilities.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { KillswitchListCapabilitiesResult } from "../models/components/killswitchlistcapabilitiesresult.js";
import {
  KillswitchesListCapabilitiesRequest,
  KillswitchesListCapabilitiesSecurity,
} from "../models/operations/killswitcheslistcapabilities.js";
import { unwrapAsync } from "../types/fp.js";
export type KillswitchCapabilitiesQueryData = KillswitchListCapabilitiesResult;

export function prefetchKillswitchCapabilities(
  queryClient: QueryClient,
  client$: GramCore,
  security: KillswitchesListCapabilitiesSecurity,
  request?: KillswitchesListCapabilitiesRequest | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildKillswitchCapabilitiesQuery(
      client$,
      security,
      request,
      options,
    ),
  });
}

export function buildKillswitchCapabilitiesQuery(
  client$: GramCore,
  security: KillswitchesListCapabilitiesSecurity,
  request?: KillswitchesListCapabilitiesRequest | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<KillswitchCapabilitiesQueryData>;
} {
  return {
    queryKey: queryKeyKillswitchCapabilities({
      gramSession: request?.gramSession,
    }),
    queryFn: async function killswitchCapabilitiesQueryFn(
      ctx,
    ): Promise<KillswitchCapabilitiesQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(killswitchesListCapabilities(
        client$,
        security,
        request,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyKillswitchCapabilities(
  parameters: { gramSession?: string | undefined },
): QueryKey {
  return ["@gram/client", "killswitches", "listCapabilities", parameters];
}
